import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ServidorService extends GenericService {
    private path = environment.url + 'api/v1/';

    constructor(http: HttpClient) {
        super(http);
    }

    getServidor(dadosServidor): Observable<any> {
        const começaComNúmero = /^\d/.test(dadosServidor);
        let nome = '';
        let matricula = 0;

        if (começaComNúmero) {
            matricula = dadosServidor;
        } else {
            nome = dadosServidor;
        }
        return this.http.get<any>(this.path + `servidor/busca-nome-matricula?nome=${nome}&matricula=${matricula}&pagina=0&itens=10`);
    }
}
